import React from 'react';
import { ServicePage } from '../ServicePage';

const CONFIG = {
  title: 'Micro-soudure Carte Mère Villeurbanne / Lyon — Récupération Données | PHONELAB 69',
  metaDescription: '✅ Micro-soudure professionnelle Villeurbanne / Lyon. Réparation carte mère iPhone & Android, récupération de données, reballing BGA, puce de charge. Quand tout le monde dit non. ☎ 04 26 00 82 10',
  icon: '🔬',
  badge: 'Micro-soudure & Carte Mère — Villeurbanne / Lyon',
  h1: 'Micro-soudure\nVilleurbanne & Lyon',
  subtitle: 'Votre téléphone ne s\'allume plus et personne ne peut rien faire ? La micro-soudure de carte mère est souvent la dernière solution — et nous la maîtrisons.',
  stats: [
    { icon: '🔬', label: 'Microscope binoculaire' },
    { icon: '🛡️', label: 'Devis avant travaux' },
    { icon: '💾', label: 'Récupération données' },
    { icon: '✅', label: 'Diagnostic GRATUIT' },
  ],
  servicesTitle: 'Interventions micro-soudure disponibles à Villeurbanne',
  services: [
    {
      icon: '⚡',
      name: 'Puce de charge (IC) iPhone',
      models: 'Tristar U2, Hydra, SN2501 — iPhone ne charge plus malgré un connecteur neuf',
      duration: '24 à 48h',
    },
    {
      icon: '🔋',
      name: 'Circuit alimentation (PMIC)',
      models: 'Téléphone éteint qui ne réagit plus à aucune charge ou bouton',
      duration: '24 à 48h',
    },
    {
      icon: '📡',
      name: 'Reballing BGA — GPU / CPU / RAM',
      models: 'Résoudage des puces BGA dessoudées par choc thermique ou chute',
      duration: '48 à 72h',
    },
    {
      icon: '💾',
      name: 'Récupération de données NAND / eMMC',
      models: 'Photos, contacts, vidéos récupérés depuis puce mémoire inaccessible',
      duration: '48 à 72h',
    },
    {
      icon: '🔌',
      name: 'Court-circuit carte mère',
      models: 'Téléphone chauffe sans s\'allumer — localisation du court-circuit au microscope',
      duration: '24 à 48h',
    },
    {
      icon: '🔩',
      name: 'Piste arrachée / condensateur CMS',
      models: 'Réparation micro-composants (résistances, condensateurs, transistors)',
      duration: '24 à 48h',
    },
    {
      icon: '📶',
      name: 'Puce Wi-Fi / Bluetooth / Réseau',
      models: 'Perte totale Wi-Fi, Bluetooth, signal réseau — remplacement du composant RF',
      duration: '48 à 72h',
    },
    {
      icon: '⚙️',
      name: 'Connecteur USB-C / Lightning (micro-soudure)',
      models: 'Connecteur arraché avec ses pistes — rebrasage direct sur carte mère',
      duration: '48h',
    },
    {
      icon: '🍎',
      name: 'Micro-soudure MacBook',
      models: 'Carte logique MacBook Air & Pro — puce de charge MagSafe, GPU, RAM',
      duration: '48 à 72h',
    },
  ],
  guarantee: {
    duration: 'Devis fixe avant travaux',
    label: 'Résultat non garanti selon gravité',
    speed: 'Délai 24 à 72h',
  },
  faq: [
    {
      q: 'C\'est quoi la micro-soudure sur téléphone ?',
      a: 'La micro-soudure est une technique de réparation au niveau de la carte mère — là où les gros réparateurs s\'arrêtent. À l\'aide d\'un microscope binoculaire et d\'un fer à souder de précision, nous intervenons directement sur les composants électroniques (puces, résistances, condensateurs, pistes) invisibles à l\'œil nu. C\'est le dernier recours avant le changement d\'appareil.',
    },
    {
      q: 'Mon téléphone ne s\'allume plus du tout — la micro-soudure peut aider ?',
      a: 'Dans la plupart des cas, oui. Un téléphone complètement mort sans réaction (pas de vibration, pas de chaleur, pas de chargement) a souvent un problème d\'alimentation sur la carte mère. Notre diagnostic gratuit permet d\'identifier la panne exacte avant de vous donner un devis. Si la réparation est impossible, aucun frais de diagnostic.',
    },
    {
      q: 'Peut-on récupérer mes photos et données si mon téléphone est détruit ?',
      a: 'Souvent oui, même quand l\'écran est totalement mort ou que la carte mère est endommagée. Nous lisons directement la puce mémoire NAND ou eMMC pour extraire vos photos, contacts et vidéos. Le taux de succès dépend de l\'état physique de la puce mémoire. Diagnostic préalable obligatoire — contact immédiat au 04 26 00 82 10.',
    },
    {
      q: 'Combien coûte une réparation en micro-soudure à Villeurbanne ?',
      a: 'Le tarif dépend entièrement de la panne identifiée lors du diagnostic. PHONELAB 69 vous fournit toujours un devis fixe et détaillé AVANT de commencer les travaux — aucune mauvaise surprise. Si la réparation est jugée impossible ou non rentable par rapport au prix d\'un appareil de remplacement, nous vous le disons honnêtement.',
    },
  ],
  ctaTitle: 'Votre appareil a une seconde chance',
  ctaSubtitle: 'Diagnostic gratuit · Devis avant travaux · Expertise unique à Villeurbanne',
};

export default function MicroSoudurePage() {
  return <ServicePage config={CONFIG} />;
}
